var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 15.4999C17.8682 15.5007 17.7377 15.4755 17.6159 15.4257C17.4941 15.3759 17.3833 15.3026 17.2898 15.2099L12.7098 10.6199C12.6169 10.5262 12.5063 10.4518 12.3844 10.401C12.2625 10.3503 12.1318 10.3241 11.9998 10.3241C11.8678 10.3241 11.7371 10.3503 11.6152 10.401C11.4934 10.4518 11.3828 10.5262 11.2898 10.6199L6.70982 15.2099C6.52152 15.3982 6.26612 15.504 5.99982 15.504C5.73352 15.504 5.47812 15.3982 5.28982 15.2099C5.10152 15.0216 4.99573 14.7662 4.99573 14.4999C4.99573 14.3681 5.0217 14.2375 5.07216 14.1157C5.12262 13.9939 5.19658 13.8832 5.28982 13.7899L9.87982 9.20994C10.4498 8.66237 11.2095 8.35657 11.9998 8.35657C12.7902 8.35657 13.5499 8.66237 14.1198 9.20994L18.7098 13.7899C18.8035 13.8829 18.8779 13.9935 18.9287 14.1154C18.9795 14.2372 19.0056 14.3679 19.0056 14.4999C19.0056 14.6319 18.9795 14.7626 18.9287 14.8845C18.8779 15.0064 18.8035 15.117 18.7098 15.2099C18.6164 15.3026 18.5056 15.3759 18.3837 15.4257C18.2619 15.4755 18.1314 15.5007 17.9998 15.4999Z",
    fill: "#FF7206"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUp);
export default __webpack_public_path__ + "static/media/icon-arrow-up.3a00a1a9949a73c1f92371571fca3b2c.svg";
export { ForwardRef as ReactComponent };